export const STORAGE_KEYS = {
  CURRENT_STORE_ID: 'currentStoreId',
  SELECTED_TAG_ID: 'selectedTagId',
  JWT_ACCESS_TOKEN: 'jwt_access_token',
  START_PAGE_URL: 'startPageUrl',
  JWT_IMPOSTOR_TOKEN: 'jwt_impostor_token',
  USER_ID_LB: 'user_id_lb',
  // Brand switching keeps its own pair of keys rather than reusing the impostor ones:
  // an LB admin impersonating a merchant who then switches brand must still be able to
  // get back to the admin back-office.
  ACTIVE_FRANCHISE_ID: 'activeFranchiseId',
  OWN_ACCESS_TOKEN: 'own_access_token',
  OWN_USER_ID: 'own_user_id',
  // Set once the operator has answered the brand question, so a reload does not
  // send them back to the picker. Cleared on logout.
  BRAND_PICKED: 'brandPicked',
  // Per-device choice between the mobile and the full dashboard; absent until the merchant picks.
  VIEW_MODE: 'viewMode',
  // sessionStorage, not local: one delegated-session recovery per page lifecycle.
  DELEGATED_RECOVERY: 'delegatedSessionRecovery',
};
